<!-- Label field -->
<mat-form-field [style.display]=" editingMode == 'label' ? '' : 'none'" appearance="outline" hideRequiredMarker="true">
  <mat-label>{{title}}</mat-label>

  <input validatorColor #label id="{{labelHtmlId}}" spellcheck="false" autocomplete="false" [formControl]="labelFormControl" matInput
    (keydown.enter)="switchToValueMode()" (keydown.tab)="switchToValueMode()" placeholder="{{labelFieldPlaceholder}}"
    type="text" (blur)="switchToValueMode()" />
  <mat-hint></mat-hint>

  <button mat-icon-button matSuffix (click)="switchToValueMode()"
    *ngIf="!(!labelFormControl?.dirty) && !(labelFormControl?.value == '') && !(!labelFormControl?.valid)">
    <mat-icon class="done-icon">skip_next</mat-icon>
  </button>

  <mat-icon matSuffix class="done-icon" *ngIf="!!(!labelFormControl?.valid)  && valueFormControl.value !=''"
    class="done-icon">error_outline</mat-icon>

</mat-form-field>

<!-- Value Field -->
<mat-form-field [style.display]=" editingMode == 'value' ? '' : 'none'" appearance="outline" hideRequiredMarker="true"
  floatLabel="always">
  <mat-label>{{labelFormControl.value}}</mat-label>

  <input validatorColor #value id="{{valueHtmlId}}" spellcheck="false" autocomplete="false" (keydown.enter)="onCommit()"
    (keydown.tab)="onCommit()" (keydown.BACKSPACE)="switchToLabelMode()" [formControl]="valueFormControl" matInput
    placeholder="{{valueFieldPlaceholder}}" type="text" (blur)="onCommit()" />

  <mat-icon matSuffix *ngIf="!!(!valueFormControl?.valid) && valueFormControl.value !=''" class="done-icon">
    error_outline</mat-icon>

</mat-form-field>
